import busyPuddingImage from '@/assets/images/character/pudding_busy.gif';
import { Box, Button, ButtonProps, CardMedia, Typography } from '@mui/material';
import React, { useMemo } from 'react';

interface PropType {
    type: 'basic' | 'custom' // 계속 추가 가능
    description?: string;
    actionArea?: React.ReactNode
}
export default function DataGridNoRows({ type, description = '', actionArea }: PropType) {
    if (type === 'basic') {
        return (
            <Box className="flex flex-col items-center justify-center h-full" sx={{ gap: 2 }}>
                <CardMedia
                    src={busyPuddingImage}
                    sx={{ width: '150px' }}
                    component={'img'} />
                <Typography variant='h6' fontWeight={600}>
                    {!!description ? description : '리스트가 없습니다.'}
                </Typography>
                {!!actionArea && (
                    <div className="flex items-center justify-center gap-10">
                        {actionArea}
                    </div>
                )}
            </Box>
        )
    }
    return <></>
}